import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoiceByInvoiceNumber";

type cartStatusProps = Parameters<typeof RequestDataFromApi>[0];

addToChainAfter(chain, RequestDataFromApi, props => {
    const existingInvData = props.getState().data.invoices.byId[props.parameter.invoiceNumber];

    if (existingInvData != null) {
        props.apiResult.notes = existingInvData.notes;
        props.apiResult.currentBalance = existingInvData.currentBalance;
        props.apiResult.currentBalanceDisplay = existingInvData.currentBalanceDisplay;
    }
});
